import { Button, Typography } from "@repo/design-system";

interface IDataPageHeaderProps {
  total: number;
  activeFilterCount: number;
  isDownloading: boolean;
  downloadProgress: number | null;
  onOpenFilters: () => void;
  onDownload: () => void;
}

export function DataPageHeader({
  total,
  activeFilterCount,
  isDownloading,
  downloadProgress,
  onOpenFilters,
  onDownload,
}: IDataPageHeaderProps) {
  return (
    <div className="flex flex-shrink-0 flex-wrap items-center justify-between gap-3">
      <div className="flex flex-col gap-1">
        <Typography variant="heading-3" className="text-contentPrimary">
          Compound Library
        </Typography>
        <Typography
          variant="paragraph-l-regular"
          className="text-contentSecondary">
          {total.toLocaleString()} compounds
          {activeFilterCount > 0 && (
            <span className="ml-1 text-contentBrand">
              · filtered by {activeFilterCount} filter
              {activeFilterCount > 1 ? "s" : ""}
            </span>
          )}
        </Typography>
        <Typography
          variant="paragraph-m-regular"
          className="text-contentTertiary">
          Click a row to select it, then download your selected compounds.
        </Typography>
      </div>

      <div className="flex items-center gap-2">
        <Button
          variant="secondary"
          leftIcon="parameters"
          onPress={onOpenFilters}
          size="small">
          {activeFilterCount > 0 ? `Filters · ${activeFilterCount}` : "Filters"}
        </Button>
        <Button
          variant="secondary"
          leftIcon={isDownloading ? undefined : "download"}
          loading={isDownloading}
          isDisabled={isDownloading}
          onPress={onDownload}
          size="small">
          {isDownloading
            ? downloadProgress !== null
              ? `${downloadProgress}% downloaded`
              : "Downloading…"
            : "Download data"}
        </Button>
      </div>
    </div>
  );
}
